import React from "react";

const StoryGenerator = () => {
  return (
    <div className="story-generator-page">
      <h1>Story Generator</h1>
      <p>Export your cards and generate stories with AI.</p>
      {/* TODO: Export options, AI integration, story preview */}
    </div>
  );
};

export default StoryGenerator; 